import { SortOrder } from '@Utils/helpers/sortingHelpers';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import _isNil from 'lodash/isNil';
import { RootState } from '@Services/redux/Store';
import { getSortedFiles } from './Helpers';
import { DownloadFilesSortField, IQcFileResult } from './Interfaces';
import { initialFilesState } from './State';

const FileSlice = createSlice({
    name: 'Files',
    initialState: initialFilesState,
    reducers: {
        setFileHeadersState(state, action) {
            state.fileId = action.payload.fileId;
            state.fileHeaders = action.payload.fileHeaders;
        },
        setFileUploadStep(state, action) {
            state.currentStep = action.payload;
        },
        setLatField(state, action) {
            state.selectedLatField = action.payload;
        },
        setLngField(state, action) {
            state.selectedLngField = action.payload;
        },
        setPoleIdField(state, action) {
            state.selectedPoleIdField = action.payload;
        },
        resetState() {
            return initialFilesState;
        },
        setWorkflowEngineState(state, action) {
            state.workflowEngineState = action.payload;
        },
        addSequentialUploadingId(state, action) {
            state.uploadingFileNotificationIds.push(action.payload);
        },
        removeSequentialUploadingId(state, action) {
            const index = state.uploadingFileNotificationIds.findIndex(
                (i) => i === action.payload
            );
            state.uploadingFileNotificationIds.splice(index, 1);
        },
        setTableSorting(state, action) {
            state.downloadFilesSortField = action.payload.field;
            state.downloadFilesSortOrder = action.payload.order;
        },
        setUploadedQcFiles(state, action) {
            state.qcFiles = action.payload;
        },
    },
});

export const FileActions = FileSlice.actions;

export const fileUploadCurrentStep = (state: RootState) =>
    state.files.currentStep;
export const fileUploadHeaders = (state: RootState) => state.files.fileHeaders;
export const fileUploadLatField = (state: RootState) =>
    state.files.selectedLatField;
export const fileUploadLngField = (state: RootState) =>
    state.files.selectedLngField;
export const fileUploadPoleIdField = (state: RootState) =>
    state.files.selectedPoleIdField;
export const fileUploadFileIdField = (state: RootState) => state.files.fileId;
export const fileWorkflowEngineState = (state: RootState) =>
    state.files.workflowEngineState;
export const downloadFilesSortFieldState = (
    state: RootState
): DownloadFilesSortField => state.files.downloadFilesSortField;
export const downloadFilesSortOrderState = (state: RootState): SortOrder =>
    state.files.downloadFilesSortOrder;
export const qcFilesState = (state: RootState): Array<IQcFileResult> =>
    state.files.qcFiles;
export const sortedDownloadFilesState = createSelector(
    downloadFilesSortFieldState,
    downloadFilesSortOrderState,
    qcFilesState,
    (field, order, files) => getSortedFiles(files, order, field)
);

export default FileSlice.reducer;
